import Swiper from "swiper";

const discoverVirtuallyEl = Array.from(
    document.querySelectorAll(".discover-virtually .swiper-container")
);
const brandsCarouselEl = Array.from(
    document.querySelectorAll(".brands-carousel .swiper-container")
);
const heroCarouselEl = Array.from(document.querySelectorAll(".hero__slider .swiper-container"));

export default function () {
    // Discover virtually

    if (discoverVirtuallyEl.length) {
        discoverVirtuallyEl.forEach((swiperEl) => {
            var swiper = new Swiper(swiperEl, {
                slidesPerView: 1.1,
                simulateTouch: false,
                spaceBetween: 16,
                // Navigation arrows
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    600: {
                        slidesPerView: 2,
                        spaceBetween: 0,
                    },
                    900: {
                        slidesPerView: 3,
                        spaceBetween: 0,
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 0,
                    },
                },
            });
        });
    }

    if (brandsCarouselEl.length) {
        brandsCarouselEl.forEach((swiperEl) => {
            var swiper = new Swiper(swiperEl, {
                // loop: true,
                slidesPerView: 1.4,
                simulateTouch: false,
                spaceBetween: 16,
                // Navigation arrows
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    600: {
                        centeredSlides: true,
                        slidesPerView: 2,
                        centeredSlides: false,
                    },
                    900: {
                        slidesPerView: 3,
                        centeredSlides: false,
                    },
                    1200: {
                        slidesPerView: 4,
                        centeredSlides: false,
                    },
                },
            });
        });
    }

    if (heroCarouselEl.length) {
        heroCarouselEl.forEach((swiperEl) => {
            var swiper = new Swiper(swiperEl, {
                slidesPerView: 1,
                effect: "fade",
                simulateTouch: false,
                loop: true,
                autoplay: {
                    delay: swiperEl.dataset.autoplaySpeed * 1000,
                    disableOnInteraction: false,
                },
            });
        });
    }
}
